import src from "IMAGE";
export default { src, width: 30, height: 690, blurWidth: 1, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAICAYAAAA4GpVBAAAAK0lEQVR42mOwDkjLZhDxauhi4DaJyWDgsy+sYeCzy6uEcEW9G7sZbAJSswDDAQn/C3ZRXQAAAABJRU5ErkJggg=="};
